import type { ScreenModule } from "../../../app/screen-module";
import { AgentBuilderPage } from "../pages";

export default {
	id: "system-admin.agents",
	path: "/system/agents",
	area: "system-admin",
	navGroup: "カタログ",
	label: "Agent Builder",
	roles: ["platform_admin", "platform_viewer"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: AgentBuilderPage,
} satisfies ScreenModule;
